export const APP_CONFIG = {
  name: "Peak4 Frontend",
  version: "1.0.0",
  description: "Peak4 Frontend",
} as const;

export const ROUTES = {
  LOGIN: "/",
  SIGN_UP: "/sign-up",
  RESET_PASSWORD: "/reset-password",
  RESET: "/reset",
  REGISTER_INTEREST: "/register-interest",
  INVITE: "/invite",
  VERIFY_INVITE: "/verify-invite",
  FAQ: "/faq",
  ASSESSMENT: "/assessment",
  CONNECT_DEVICE: "/connect-device",
  WHOOP_CALLBACK: "/whoop-callback",
  FITBIT_CALLBACK: "/fitbit-callback",
  COMPLETE: "/complete",
  DASHBOARD: "/dashboard",
  ADMIN_DASHBOARD: "/admin/dashboard",
  RECOVERY: "/admin/recovery",
  SLEEP_ANALYTICS: "/admin/sleep-analytics",
  STRAIN_AND_ACTIVITY: "/admin/strain-activity",
  JEOPARDY_INSIGHTS: "/admin/jeopardy-insights",
  MEASURE_COMPARISON_INSIGHTS: "/admin/measure-comparison",
  PREDICTIVE_INSIGHTS: "/admin/predictive-insights",
  SETTINGS: "/admin/settings",
  SETTINGS_CLIENTS: "/admin/settings/clients",
  SETTINGS_PLATFORM: "/admin/settings/platform",
  SETTINGS_PARTICIPANTS: "/admin/settings/participants",
  SETTINGS_PARTICIPANT_SETTINGS: "/admin/settings/participant-settings",
  SETTINGS_PRE_REGISTRATIONS: "/admin/settings/pre-registrations",
  SETTINGS_WELLBEING_CONTENT: "/admin/settings/wellbeing-content",
  WELLBEING_CONTENT: "/admin/wellbeing-content",
  NEWS_FEED: "/admin/news-feed",
  RECIPES_CONTENT: "/admin/recipes",
  PRE_REGISTRATIONS: "/admin/pre-registrations",
  PARTICIPANTS: "/admin/participants",
  PARTICIPANT_SETTINGS: "/admin/participant-settings",
  USER_PROGRESS: "/admin/user-progress",
} as const;

export const API_ENDPOINTS = {
  BASE_URL:
    import.meta.env.VITE_API_URL || "https://localhost:8080",
  USERS: "/users",
  AUTH: "/auth",
} as const;
